module.exports = __webpack_public_path__ + "static/perist-ecd3b3c79c0bbe9e142ed0bf834377b3.pdf";